import React from 'react';  
import { Link } from "react-router-dom";

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faCheckSquare, faDoorClosed, faDoorOpen, faSmile } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
library.add(fab, faCheckSquare, faDoorClosed, faDoorOpen, faSmile)

class Popup extends React.Component {  
  render() {  
    return (
        <div className="container">
            <div className="row">

                    <div id="normal" className="col-md-3 top-comment-grid">
                        <div className="comments views">
                            <Link to={`${process.env.PUBLIC_URL}/`} className="navbar-brand">
                                <div className="comments-icon">
                                <FontAwesomeIcon icon="fa-smile" size="6x" color="yellow"/>                                    
                                </div>
                                <div className="comments-info likes-info" style={{color: '#FFF'}}>
                                    <h3 style={{'fontSize': '2em','color': '#FFF'}}>Gracias!!</h3>
                                    Fichada correcta
                                </div>
                            </Link>
                            <div className="clearfix"> </div>
                        </div>
                    </div>
                    
            </div>
        </div>
    );
    
  }  
}  

export default Popup;











